export default __webpack_public_path__ + "static/media/nft-thumbnail.eeedcc4a.png";